import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CssBaseline } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { ModalContext } from '../../material';
import { C2FOTheme, LiquidityTheme, useTheme } from '../../themes';
import { ThemeProvider } from '../ThemeProvider';
const useStyles = makeStyles(() => ({
    root: {
        filter: ({ rootBlur }) => (rootBlur ? 'blur(1.5px)' : 'none'),
        minHeight: '100%',
    },
}));
const themes = {
    c2fo: C2FOTheme,
    liquidity: LiquidityTheme,
};
/**
 * A component that uses a ReactDOM portal to render a link in the head of the document.
 * This is used to load the Liquidity theme fonts.
 * If the theme is not 'liquidity', this component will render null.
 */
const LiquidityFontManager = () => {
    const theme = useTheme();
    if (theme.name !== 'liquidity') {
        return null;
    }
    return createPortal(_jsx("link", { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Libre+Baskerville&family=Roboto:wght@300;400;500;700&display=swap" }, void 0), document.head);
};
/**
 * The root provider for the C2FO Components library.
 * This provides the theme information for react-components and assiciated components to key in on for styling, theming,
 * etc.
 */
export const C2foComponentsRootProvider = ({ theme: themeName = 'c2fo', children, }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const classes = useStyles({
        rootBlur: isModalOpen,
    });
    const theme = useMemo(() => themes[themeName], [themeName]);
    return (_jsxs(ThemeProvider, Object.assign({ theme: theme }, { children: [_jsx(CssBaseline, {}, void 0),
            _jsx(LiquidityFontManager, {}, void 0),
            _jsx(ModalContext.Provider, Object.assign({ value: { isModalOpen, setModalOpen } }, { children: _jsx("div", Object.assign({ className: classes.root }, { children: children }), void 0) }), void 0)] }), void 0));
};
//# sourceMappingURL=C2foComponentsRootProvider.js.map